const CLAMP_CLASSES: Record<number, string> = {
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4",
  6: "line-clamp-6",
};

interface ClampedTextProps {
  text: string;
  lines?: 2 | 3 | 4 | 6;
  className?: string;
}

/** Pre-wrapped text cut to a few lines. */
export default function ClampedText({ text, lines = 2, className = "" }: ClampedTextProps) {
  return (
    <div className="min-w-0">
      <p className={`whitespace-pre-wrap break-words ${CLAMP_CLASSES[lines]} ${className}`}>{text}</p>
    </div>
  );
}
